import {
  Checkbox,
  Button,
  Box,
  Switch,
  FormGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { FormControlLabel, IconButton, TextField, MenuItem } from "@mui/material";
import cogoToast from "cogo-toast";
import React, { Fragment, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, setBackendJobs } from "../../../Utils/actions";
import SaveIcon from "@mui/icons-material/Save";
import "../../../App.css";
import { useLocation } from "react-router-dom";
import "./BackendJobs.css";
import { loadingOn } from "../../../Utils/utils";
import { buttonStyle } from "../../../Style/ManualStyle";

const BackendJobs = ({ setTabs }) => {
  const [form, setForm] = useState({
    cleanup: "Y",
    cleanupTime: 1,
    threshold: "Y",
    cleanupThresholdTime: 0,
    sync: "Y",
    syncTime: 1,
    templateManager: "Y",
    templateManagerTime: 1,
    autoSync: "Y",
    dataPersistence: "Y",
    bufferCleanUpTime: 0,

    host: "192.168.2.26",
    port: "9998",
    secure: "N",
    userName: "brijesh",
    password: "Init@123",
    msHost: "",
    msPort: "",
    msApiKey: "",
    msServerUrl: "",
    forceStart: "N",
    interval: 0,
    depthInterval: 0,
    liveRecords: "Y",
    liveRecordsTime: 0,
    templateManagerHazelcastTime: 10,
    logRoot: "INFO",
    logFilePath: "",
    rawCleanup: "N",
    rawCleanupTime: 1,
    backupData: 300000,
    backupDataDepth: 100,
    dbMode: "N",
    finishProcessing: "N",
    availableSleep: 1,
    witsmlBatchSize: 0,
    activityThreshold: 100,
    qualitySync: "N",
    depthSeriesDelayFeet: 100,
  });
  const [error, setError] = useState({
    cleanup: "",
    cleanupTime: "",
    threshold: "",
    cleanupThresholdTime: "",
    sync: "",
    syncTime: "",
    templateManager: "",
    templateManagerTime: "",
    dataPersistence: "",
    bufferCleanUpTime: "",
    autoSync: "",
    host: "",
    port: "",
    secure: "",
    userName: "",
    password: "",
    msHost: "",
    msPort: "",
    msApiKey: "",
    msServerUrl: "",
    forceStart: "",
    interval: '',
    depthInterval: '',
    liveRecords: "",
    liveRecordsTime: '',
    templateManagerHazelcastTime: '',
    logRoot: "",
    logFilePath: "",
    rawCleanup: "",
    rawCleanupTime: "",
    backupData: "",
    backupDataDepth: "",
    dbMode: "",
    finishProcessing: "",
    availableSleep: "",
    witsmlBatchSize: "",
    activityThreshold: "",
    qualitySync: "",
    depthSeriesDelayFeet: "",
  });
  const { resourcesData } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const location = useLocation();
  const [render, setRender] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirmSubmit = (e) => {
    handleSubmit(e);
    handleCloseConfirm();
  };
  const handleChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value.toString() });
  };

  const apiCall = () => {
    dispatch(getAllJobs());
  };

  useEffect(() => {
    if (
      location.pathname === "/configForm" ||
      location.pathname === "/appConfig"
    ) {
      apiCall();
    }
  }, []);

  useEffect(() => {
    if (Object.keys(resourcesData).length > 0) {
      setForm({
        ...form,
        ...resourcesData,
        // cleanup: "Y",
        // threshold: "Y",
        // sync: "Y",
        // templateManager: "Y",
      });
    }
  }, [resourcesData]);

  const handleCheckChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value === "Y" ? "N" : "Y" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = { ...error };

    // Reset errors
    Object.keys(newErrors).forEach((key) => (newErrors[key] = ""));

    // Validate all fields
    // if (form.cleanup === "Y") {
    if (form.cleanupTime === "" || form.cleanupTime === null || form.cleanupTime === undefined) {
  newErrors.cleanupTime = "Clean DQ Result Time is required";
}

if (form.cleanupThresholdTime === "" || form.cleanupThresholdTime === null || form.cleanupThresholdTime === undefined) {
  newErrors.cleanupThresholdTime = "Threshold Time is required";
}

if (form.syncTime === "" || form.syncTime === null || form.syncTime === undefined) {
  newErrors.syncTime = "Sync Time is required";
}

if (form.rawCleanupTime === "" || form.rawCleanupTime === null || form.rawCleanupTime === undefined) {
  newErrors.rawCleanupTime = "Raw Cleanup Time is required";
}

if (form.liveRecordsTime === "" || form.liveRecordsTime === null || form.liveRecordsTime === undefined) {
  newErrors.liveRecordsTime = "Live Records Time is required";
}

if (form.bufferCleanUpTime === "" || form.bufferCleanUpTime === null || form.bufferCleanUpTime === undefined) {
  newErrors.bufferCleanUpTime = "Buffer Cleanup Time is required";
}

// String fields (safe to trim)
if (!form.host || !form.host.trim()) {
  newErrors.host = "Host is required";
}
if (!form.port && form.port !== 0) { // assuming number
  newErrors.port = "Port is required";
}
if (!form.userName || !form.userName.trim()) {
  newErrors.userName = "User Name is required";
}
if (!form.password || !form.password.trim()) {
  newErrors.password = "Password is required";
}

// Interval & numeric validations
if (form.interval === "" || form.interval === null || form.interval === undefined) {
  newErrors.interval = "Interval is required";
}

if (form.depthInterval === "" || form.depthInterval === null || form.depthInterval === undefined) {
  newErrors.depthInterval = "Depth Interval is required";
}

if (form.backupData === "" || form.backupData === null || form.backupData === undefined) {
  newErrors.backupData = "Backup Data is required";
}

if (form.backupDataDepth === "" || form.backupDataDepth === null || form.backupDataDepth === undefined) {
  newErrors.backupDataDepth = "Backup Data Depth is required";
}

if (form.availableSleep === "" || form.availableSleep === null || form.availableSleep === undefined) {
  newErrors.availableSleep = "Available Sleep is required";
}

if (form.activityThreshold === "" || form.activityThreshold === null || form.activityThreshold === undefined) {
  newErrors.activityThreshold = "Activity Threshold is required";
}

if (form.depthSeriesDelayFeet === "" || form.depthSeriesDelayFeet === null || form.depthSeriesDelayFeet === undefined) {
  newErrors.depthSeriesDelayFeet = "Depth Series Delay Feet is required";
}

if (form.templateManagerTime === "" || form.templateManagerTime === null || form.templateManagerTime === undefined) {
  newErrors.templateManagerTime = "Template Manager Time is required";
}

if (form.templateManagerHazelcastTime === "" || form.templateManagerHazelcastTime === null || form.templateManagerHazelcastTime === undefined) {
  newErrors.templateManagerHazelcastTime = "Template Manager Hazelcast Time is required";
}


    // Update error state with all errors
    setError(newErrors);

    // Check for any errors
    const hasErrors = Object.values(newErrors).some((err) => err !== "");
    if (hasErrors) {
      console.log("Errors found:", newErrors); // Debugging
      return;
    }

    // Proceed with submission
    const data = [
      { propertyKey: "iot.server.cleanup", propertyValue: form.cleanup },
      { propertyKey: "iot.server.cleanup.time", propertyValue: form.cleanupTime },
      { propertyKey: "iot.server.cleanup.thresholdTime", propertyValue: form.cleanupThresholdTime },
      { propertyKey: "iot.server.sync", propertyValue: form.sync },
      { propertyKey: "iot.server.sync.time", propertyValue: form.syncTime },
      { propertyKey: "iot.server.start.autoSync", propertyValue: form.autoSync },
      { propertyKey: "iot.server.start.template.manager", propertyValue: form.templateManager },
      { propertyKey: "iot.server.template.manager.time", propertyValue: form.templateManagerTime },
      { propertyKey: "iot.server.template.manager.hazelcast.time", propertyValue: form.templateManagerHazelcastTime },
      { propertyKey: "iot.veras.dq.template.provider.host", propertyValue: form.host },
      { propertyKey: "iot.veras.dq.template.provider.port", propertyValue: form.port },
      { propertyKey: "iot.veras.dq.template.provider.secure", propertyValue: form.secure },
      { propertyKey: "iot.veras.dq.template.provider.username", propertyValue: form.userName },
      { propertyKey: "iot.veras.dq.template.provider.password", propertyValue: form.password },
      { propertyKey: "iot.veras.dq.template.force.start", propertyValue: form.forceStart },
      { propertyKey: "iot.veras.dq.template.read.raw.data.interval", propertyValue: form.interval },
      { propertyKey: "iot.veras.dq.template.depth.read.raw.data.interval", propertyValue: form.depthInterval },
      { propertyKey: "iot.veras.dq.job.buffercleanUp.interval", propertyValue: form.bufferCleanUpTime },
      { propertyKey: "iot.server.dataPersistence", propertyValue: form.dataPersistence },
      { propertyKey: "yh.server.integration.msteams.host", propertyValue: form.msHost },
      { propertyKey: "yh.server.integration.msteams.port", propertyValue: form.msPort },
      { propertyKey: "yh.server.integration.msteams.apiKey", propertyValue: form.msApiKey },
      { propertyKey: "yh.server.integration.msteams.serverUrl", propertyValue: form.msServerUrl },
      { propertyKey: "iot.server.start.sync.live.records", propertyValue: form.liveRecords },
      { propertyKey: "iot.server.start.sync.live.records.time", propertyValue: form.liveRecordsTime },
      { propertyKey: "logging.level.root", propertyValue: form.logRoot },
      { propertyKey: "iot.source.logger.filepath", propertyValue: form.logFilePath },
      { propertyKey: "iot.server.start.raw.cleanup", propertyValue: form.rawCleanup },
      { propertyKey: "iot.server.raw.data.cleanup.time", propertyValue: form.rawCleanupTime },
      { propertyKey: "iot.veras.dq.quailty.backup.data", propertyValue: form.backupData },
      { propertyKey: "iot.veras.dq.quailty.backup.data.depth", propertyValue: form.backupDataDepth },
      { propertyKey: "iot.veras.dq.flow.db.mode", propertyValue: form.dbMode },
      { propertyKey: "iot.veras.dq.check.finish.processing", propertyValue: form.finishProcessing },
      { propertyKey: "iot.veras.no.data.available.sleep", propertyValue: form.availableSleep },
      { propertyKey: "iot.veras.witsml.batch.size", propertyValue: form.witsmlBatchSize },
      { propertyKey: "iot.veras.declare.skid.activity.threshold", propertyValue: form.activityThreshold },
      { propertyKey: "operator.isSync.quality", propertyValue: form.qualitySync },
      { propertyKey: "yh.server.depth.series.additional.delay.feet", propertyValue: form.depthSeriesDelayFeet },
    ];

    try {
      dispatch(loadingOn());
      dispatch(setBackendJobs(data));
      if (location.pathname === "/validForm") {
        setTabs(1);
      }
    } catch (err) {
      cogoToast.error("Not successful");
      console.error("Submission error:", err); // Debugging
    }
  };

  const textFields = {
    margin: "5px",
    padding: "10px",
    height: "70px",
    gap: "15px",
  };
  const textFld = { margin: "5px", padding: "0px", display: "flex" };
  const switchtextFld = { marginLeft: "10px", display: "block" };

  const handleSetting = (e) => {
    let value = e.target.value === "0" ? "" : e.target.value;
    setForm({ ...form, [e.target.name]: value });
  };
  const handleCheckChange1 = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.checked }); // Update with the checked property of the checkbox
  };

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  // const appRender = (value) => {
  //     setRender(value.value[0])
  // }

  return (
    <Fragment>
      {/* top: '20px' */}
      <Card
        className={"shadow-none w-100 backendjobs-card"}
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        <Card.Body
          className={"backendjobs_content"}
          style={{
            borderRadius: "0.25rem",
            background: "#fff",
            overflow: "auto",
            backgroundColor: "#242424",
            // padding: "0px",
          }}
        >
          <div
            className="col-md-10 backfill-form"
            style={{ paddingTop: "5px", paddingLeft: "5px" }}
          >
            <Box
              component="form"
              className="addUserBox"
              // onSubmit={(e) => handleSubmit(e)}
              onSubmit={(e) => e.preventDefault()}
              noValidate
              autoComplete="off"
            >
              <div className="textBoxes d-block">
                <div className="main1">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginBottom: "20px",
                    }}
                  >
                    System Configuration
                  </h6>

                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          // className="switchCase"
                          name="cleanup"
                          onChange={handleCheckChange}
                          value={form.cleanup}
                          checked={form.cleanup === "Y"}
                          label="Clean DQ Result"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>
                    {form.cleanup === "Y" ? (
                      <div
                        className="app-txt"
                        style={{ textFld, flex: "0 0 200px" }}
                      >
                        <TextField
                          type="number"
                          name="cleanupTime"
                          onFocus={handleSetting}
                          label="Clean DQ Result Time (min)"
                          value={form.cleanupTime}
                          required
                          onChange={handleChange}
                          error={!!error.cleanupTime}
                          helperText={error.cleanupTime}
                          size="small"
                        />
                      </div>
                    ) : null}
                    {/* {form.cleanup === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="cleanupThresholdTime"
                        onFocus={handleSetting}
                        label="Threshold Time (min)"
                        value={form.cleanupThresholdTime}
                        required
                        onChange={handleChange}
                        error={!!error.cleanupThresholdTime}
                        helperText={error.cleanupThresholdTime}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          name="sync"
                          value={form.sync}
                          onChange={handleCheckChange}
                          checked={form.sync === "Y"}
                          label="Sync"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>
                    {/* {form.sync === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="syncTime"
                        label="Backfill time (min)"
                        onFocus={handleSetting}
                        value={form.syncTime}
                        required
                        onChange={handleChange}
                        error={!!error.syncTime}
                        helperText={error.syncTime}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                    {form.sync === "Y" ? (
                      <div
                        className="app-chk"
                        style={{ textFld, flex: "0 0 200px" }}
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 28 },
                                  color: "#286685",
                                  "&.Mui-checked": {
                                    color: "#286685",
                                  },
                                }}
                              // defaultChecked
                              />
                            }
                            value={form.autoSync}
                            onChange={handleCheckChange1}
                            checked={form.autoSync}
                            name="autoSync"
                            label="Auto sync"
                            style={{ color: "#c7c7c7" }}
                          />
                        </FormGroup>
                        {/* <TextField type='number' name="syncTime" label="Backfill time (ms)" onFocus={handleSetting} value={form.syncTime} required onChange={handleChange} error={!!error.syncTime} helperText={error.syncTime} /> */}
                      </div>
                    ) : null}
                  </div>


                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          name="dataPersistence"
                          onChange={handleCheckChange}
                          value={form.dataPersistence}
                          checked={form.dataPersistence === "Y"}
                          label="Data Persistense"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>
                    {/* {form.dataPersistence === "Y" ? ( */}
                    <div
                      style={{ textFld, flex: "0 0 200px" }}
                      className="ml-0 app-txt"
                    >
                      <TextField
                        type="number"
                        name="bufferCleanUpTime"
                        onFocus={handleSetting}
                        label="Buffer Cleanup Time (min)"
                        value={form.bufferCleanUpTime}
                        required
                        onChange={handleChange}
                        error={!!error.bufferCleanUpTime}
                        helperText={error.bufferCleanUpTime}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          // className="switchCase"
                          name="rawCleanup"
                          onChange={handleCheckChange}
                          value={form.rawCleanup}
                          checked={form.rawCleanup === "Y"}
                          label="Raw Clean Up"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>
                    {/* {form.rawCleanup === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="rawCleanupTime"
                        onFocus={handleSetting}
                        label="Raw Cleanup Time (min)"
                        value={form.rawCleanupTime}
                        required
                        onChange={handleChange}
                        error={!!error.rawCleanupTime}
                        helperText={error.rawCleanupTime}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          // className="switchCase"
                          name="liveRecords"
                          onChange={handleCheckChange}
                          value={form.liveRecords}
                          checked={form.liveRecords === "Y"}
                          label="Live Records"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>
                    {/* {form.liveRecords === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="liveRecordsTime"
                        onFocus={handleSetting}
                        label="Live Records Time (min)"
                        value={form.liveRecordsTime}
                        required
                        onChange={handleChange}
                        error={!!error.liveRecordsTime}
                        helperText={error.liveRecordsTime}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="availableSleep"
                        label="Sleep Time (min)"
                        value={form.availableSleep}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.availableSleep}
                        helperText={error.availableSleep}
                        size="small"
                      />
                    </div>
                    {/* {form.templateManager === "Y" ? ( */}
                    {/* <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="witsmlBatchSize"
                        label="witsml Batch Size"
                        value={form.witsmlBatchSize}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.witsmlBatchSize}
                        helperText={error.witsmlBatchSize}
                      />
                    </div> */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="activityThreshold"
                        label="Activity Threshold"
                        value={form.activityThreshold}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.activityThreshold}
                        helperText={error.activityThreshold}
                        size="small"
                      />
                    </div>

                    <div
                      className="user-info app-txt"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                      }}
                    >
                      <TextField
                        type="text"
                        name="depthSeriesDelayFeet"
                        label="Depth Series Delay (ft)"
                        value={form.depthSeriesDelayFeet}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.depthSeriesDelayFeet}
                        helperText={error.depthSeriesDelayFeet}
                        size="small"
                      />
                    </div>
                    <div
                      className="app-chk"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 28 },
                                color: "#286685",
                                "&.Mui-checked": {
                                  color: "#286685",
                                },
                              }}
                            // defaultChecked
                            />
                          }
                          value={form.qualitySync}
                          onChange={handleCheckChange1}
                          checked={form.qualitySync}
                          name="qualitySync"
                          label="quality sync"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                      {/* <TextField type='number' name="syncTime" label="Backfill time (ms)" onFocus={handleSetting} value={form.syncTime} required onChange={handleChange} error={!!error.syncTime} helperText={error.syncTime} /> */}
                    </div>
                  </div>
                </div>
                <div className="main2">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    DQ Template Server
                  </h6>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="app-switch"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={<Switch style={{ color: "#c7c7c7" }} />}
                          name="templateManager"
                          onChange={handleCheckChange}
                          value={form.templateManager}
                          checked={form.templateManager === "Y"}
                          label="Sync Template from Veras hub"
                          style={{ color: "#c7c7c7" }}
                        />
                      </FormGroup>
                    </div>

                    <div
                      style={{ textFld, flex: "0 0 200px" }}
                      className="ml-0 app-txt"
                    >
                      <TextField
                        type="number"
                        name="templateManagerTime"
                        onFocus={handleSetting}
                        label="Template Manager Time (min)"
                        value={form.templateManagerTime}
                        required
                        onChange={handleChange}
                        error={!!error.templateManagerTime}
                        helperText={error.templateManagerTime}
                        size="small"
                      />
                    </div>


                    <div
                      style={{ textFld, flex: "0 0 200px" }}
                      className="ml-0 app-txt"
                    >
                      <TextField
                        type="number"
                        name="templateManagerHazelcastTime"
                        onFocus={handleSetting}
                        label="Template Manager Hazelcast Time (min)"
                        value={form.templateManagerHazelcastTime}
                        required
                        onChange={handleChange}
                        error={!!error.templateManagerHazelcastTime}
                        helperText={error.templateManagerHazelcastTime}
                        size="small"
                      />
                    </div>
                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="host"
                        label="Host"
                        value={form.host}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.host}
                        helperText={error.host}
                        size="small"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >

                    {/* {form.templateManager === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="port"
                        label="Port"
                        value={form.port}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.port}
                        helperText={error.port}
                        size="small"
                      />
                    </div>
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="interval"
                        label="Interval"
                        value={form.interval}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.interval}
                        helperText={error.interval}
                        size="small"
                      />
                    </div>
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="depthInterval"
                        label="Depth Interval"
                        value={form.depthInterval}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.depthInterval}
                        helperText={error.depthInterval}
                        size="small"
                      />
                    </div>
                    <div
                      className="user-info app-txt"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        
                      }}
                    >
                      <TextField
                        type="text"
                        name="userName"
                        label="User Name"
                        value={form.userName}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.userName}
                        helperText={error.userName}
                        size="small"
                      />
                    </div>
                    {/* ) : null} */}
                  </div>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >

                    <div
                      className="app-txt"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        // marginLeft: "15px",
                        marginTop: "10px",
                      }}
                    >
                      <TextField
                        type="password"
                        name="password"
                        label="Password"
                        value={form.password}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.password}
                        helperText={error.password}
                        size="small"
                      />
                    </div>
                    <div
                      className="is-secure app-chk"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        paddingTop: "0px",
                      }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 28 },
                                color: "#286685",
                                "&.Mui-checked": {
                                  color: "#286685",
                                },
                              }}
                              value={form.secure}
                              onChange={handleCheckChange}
                              checked={form.secure === "Y"}
                              name="secure"
                            />
                          }
                          style={{ color: "#c7c7c7" }}
                          label="Secure"
                        />
                      </FormGroup>
                    </div>
                    <div
                      className="is-secure app-chk"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        paddingTop: "0px",
                      }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 28 },
                                color: "#286685",
                                "&.Mui-checked": {
                                  color: "#286685",
                                },
                              }}
                              value={form.forceStart}
                              onChange={handleCheckChange}
                              checked={form.forceStart === "Y"}
                              name="forceStart"
                            />
                          }
                          style={{ color: "#c7c7c7" }}
                          label="Force Start"
                        />
                      </FormGroup>
                    </div>
                  </div>

                </div>
                {/* <div className="main3">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    MSTeam Credentials
                  </h6>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="msHost"
                        label="Host"
                        value={form.msHost}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msHost}
                        helperText={error.msHost}
                      />
                    </div>
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="msPort"
                        label="Port"
                        value={form.msPort}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msPort}
                        helperText={error.msPort}
                      />
                    </div>
                     <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="msApiKey"
                        label="Api Key"
                        value={form.msApiKey}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msApiKey}
                        helperText={error.msApiKey}
                      />
                    </div>
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="msServerUrl"
                        label="Server Url"
                        value={form.msServerUrl}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msServerUrl}
                        helperText={error.msServerUrl}
                      />
                    </div> 
                  </div>
                </div> */}
                {/* <div className="main5">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    Log Manager
                  </h6>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        select
                        name="logRoot"
                        label="Root"
                        value={form.logRoot}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.logRoot}
                        helperText={error.logRoot}
                        fullWidth
                      >
                        <MenuItem value="DEBUG">DEBUG</MenuItem>
                        <MenuItem value="WARN">WARN</MenuItem>
                        <MenuItem value="ERROR">ERROR</MenuItem>
                        <MenuItem value="INFO">INFO</MenuItem>
                      </TextField>

                    </div>
                  
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="logFilePath"
                        label="logFilePath"
                        value={form.logFilePath}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.logFilePath}
                        helperText={error.logFilePath}
                      />
                    </div>
                   
                  </div>
                 
                </div> */}
                <div className="main6">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    Data Quality
                  </h6>
                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >
                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="backupData"
                        label="Backup Data"
                        value={form.backupData}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.backupData}
                        helperText={error.backupData}
                        size="small"
                      />
                    </div>
                    {/* {form.templateManager === "Y" ? ( */}
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="backupDataDepth"
                        label="Backup Data Depth"
                        value={form.backupDataDepth}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.backupDataDepth}
                        helperText={error.backupDataDepth}
                        size="small"
                      />
                    </div>
                    {/* <div
                      className="is-secure app-chk"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        paddingTop: "0px",
                      }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 28 },
                                color: "#286685",
                                "&.Mui-checked": {
                                  color: "#286685",
                                },
                              }}
                              value={form.dbMode}
                              onChange={handleCheckChange}
                              checked={form.dbMode === "Y"}
                              name="dbMode"
                            />
                          }
                          style={{ color: "#c7c7c7" }}
                          label="DB Mode"
                        />
                      </FormGroup>
                    </div>
                           <div
                      className="is-secure app-chk"
                      style={{
                        switchtextFld,
                        flex: "0 0 200px",
                        paddingTop: "0px",
                      }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 28 },
                                color: "#286685",
                                "&.Mui-checked": {
                                  color: "#286685",
                                },
                              }}
                              value={form.finishProcessing}
                              onChange={handleCheckChange}
                              checked={form.finishProcessing === "Y"}
                              name="finishProcessing"
                            />
                          }
                          style={{ color: "#c7c7c7" }}
                          label="Finish Processing"
                        />
                      </FormGroup>
                    </div>
                */}
                  </div>
                </div>
              </div>
              {/* </div> */}
              {location.pathname === "/validForm" ? (
                <>
                  <Button
                    className="submit-btn"
                    type="button"
                    startIcon={<SaveIcon />}
                    style={{
                      ...buttonStyle,
                      // backgroundColor: "#286685",
                      // color: "#fff",
                      width: "100px",
                      left: "15px",
                      marginTop: "10px",
                    }}
                    onClick={handleOpenConfirm}
                  >
                    Save
                  </Button>
                </>
              ) : cmpntGroup["configuration"]?.Update ||
                cmpntGroup["configuration"]?.Add ? (
                <Button
                  className="submit-btn"
                  type="button"
                  startIcon={<SaveIcon />}
                  style={{
                    ...buttonStyle,
                    // backgroundColor: "#286685",
                    // color: "#fff",
                    width: "100px",
                    left: "15px",
                    marginTop: "10px",
                  }}
                  onClick={handleOpenConfirm}
                >
                  Save
                </Button>
              ) : (
                <>
                  {cmpntGroup["configuration"]?.Update &&
                    cmpntGroup["configuration"]?.Add ? (
                    <Button
                      className="submit-btn"
                      type="button"
                      startIcon={<SaveIcon />}
                      style={{
                        ...buttonStyle,
                        // backgroundColor: "#286685",
                        // color: "#fff",
                        width: "100px",
                        left: "15px",
                        marginTop: "10px",
                      }}
                      onClick={handleOpenConfirm}
                    >
                      Save
                    </Button>
                  ) : null}
                </>
              )}
            </Box>
          </div>
        </Card.Body>
      </Card>

      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle
          id="confirm-dialog-title"
          style={{
            backgroundColor: "#464545fb",
            color: "#c7c7c7",
          }}
        >
          Confirm Save
          {/* <IconButton
            aria-label="close"
            onClick={handleCloseConfirm}
            edge="end"
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton> */}
        </DialogTitle>

        <DialogContent>
          Are you sure you want to save the changes?
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseConfirm}
            variant="contained"
            color="secondary"
            style={{ ...buttonStyle }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmSubmit}
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            style={{
              ...buttonStyle,
              // backgroundColor: "#286685",
              // color: "#fff",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BackendJobs;
